// extracted by mini-css-extract-plugin
export var cardContainer = "_n0-0";
export var cardHeader = "_n0-2";
export var collapsedState = "_n0-3";
export var dragHandle = "_n0-5";
export var dragHandleIcon = "_n0-6";
export var dragging = "_n0-1";
export var titleArea = "_n0-4";